import React, { memo, useState } from "react";
import { cn } from "utils";
import { useMemoizedFn } from "ahooks";
import LineHeaderEnd, { DataType } from "../Chat/Charts/LineHeaderEnd";
import ChartFooter from "../Chat/Charts/ChartFooter";
import ComparisonToken from "../Chat/Charts/token/ComparisonToken";
import Empty from "../Chat/Charts/Empty";
import { ChatCategoryCardType } from "../Chat/Cards/type";
import TokenDetailLine from "./TokenDetailLine";
import DetailPriceChange from "./DetailPriceChange";

interface ChartLineProps {
  className?: string;
  symbol?: string;
  priceChangeList?: any;
  id?: string;
  isPollToken?: boolean;
}
/** 组件内部没有对数据做任何格式化，需要外部处理 */
const ChartLine: React.FC<ChartLineProps> = ({
  className = "",
  symbol,
  id,
  priceChangeList,
  isPollToken,
}) => {
  const [dataType, setSelectedDataType] = useState(DataType["7D"]);
  const [selectedTokenValues, setSelectedTokenValues] = useState<string[]>([]);
  const currentSymbol = symbol;

  const onSelectedValues = useMemoizedFn((values: string[]) => {
    setSelectedTokenValues(values);
  });

  const cardItem = {
    type: "token",
    properties: { token_symbol: currentSymbol },
  } as ChatCategoryCardType;

  if (!cardItem) {
    return <Empty />;
  }

  return (
    <div className={cn("w-full", className)}>
      <LineHeaderEnd
        cardItem={cardItem}
        setSelectedDataType={setSelectedDataType}
        className="flex flex-row items-center justify-between"
      />
      <TokenDetailLine
        dataType={dataType}
        selectedTokenValues={selectedTokenValues}
        symbol={currentSymbol}
        id={id}
        isPollToken={isPollToken}
      />
      <ChartFooter
        showDataSource={false}
        startView={
          <ComparisonToken
            cardItem={cardItem}
            onSelectedValues={onSelectedValues}
            className="hidden" // 图表生成数据有问题，隐藏数据展示，预计1.21版本重新修改
          />
        }
        className="max-md:flex-col max-md:gap-2 max-md:items-end max-md:h-auto max-md:mt-0 mb-2"
      />
      <DetailPriceChange dataList={priceChangeList} />
    </div>
  );
};

export default memo(ChartLine);
